export default function getProductDisplayPrice({
  netPrice,
  exc_order_net_price
}) {
  return exc_order_net_price ? exc_order_net_price : netPrice;
}
